@if (!isMobile()) {
    <div class="app-shell" [class.app-shell--chromeless]="chromeless()">
        <app-route-progress />

        @if (!chromeless()) {
            <app-header />
        }

        <main class="app-main">
            <router-outlet />
        </main>

        <ck-toasts [defaultDelay]="4500" [hasCloseButton]="true" [showProgress]="false"></ck-toasts>
    </div>
} @else {
    <app-mobile-unsupported />
}
